import { toast } from 'react-hot-toast'

import * as Sentry from '@sentry/nextjs'

import { YANDEX_CAPTCHA_CLIENT_STAGING } from '@/config/captcha.keys'
import { SETTINGS_CLIENT } from '@/config/settings.client'

export const getCaptchaToken = (): Promise<string | void> => {
    return new Promise((resolve, reject) => {
        const sitekey =
            window.__YANDEX_CAPTCHA_SITEKEY__ ||
            SETTINGS_CLIENT.YANDEX_CAPTCHA_CLIENT ||
            YANDEX_CAPTCHA_CLIENT_STAGING

        const widgetId = window.smartCaptcha.render('captchaElement', {
            sitekey,
            invisible: true,
            callback: resolve,
            errorCallback: error => {
                toast.error('Ошибка проверки Captcha')
                Sentry.captureException(error, {
                    tags: { context: 'yandex-captcha' },
                })
                return reject(error)
            },
        })
        window.smartCaptcha.execute(widgetId)
    })
}
